import { loc, type Lang, type Loc } from './cards.ts'

/**
 * Пакеты Telegram Stars. Общие для клиента и сервера: экран оплаты обещает
 * ровно то, что сервер потом начислит, и разойтись они не могут.
 */

export interface StarPackage {
  /** Сколько звёзд стоит пакет. В Telegram это же число — сумма в Stars. */
  stars: number
  /** Сколько начисляется сверх оплаченного. */
  bonus: number
  ru: string
  az: string
  en: string
  tr: string
  best?: boolean
}

/** Пакеты Telegram Stars: цена — это число звёзд, сверху бонус. */
export const PACKAGES: StarPackage[] = [
  { stars: 100,  bonus: 0,   ru: 'Искра',     az: 'Qığılcım', en: 'Spark',           tr: 'Kıvılcım' },
  { stars: 500,  bonus: 50,  ru: 'Пламя',     az: 'Alov',     en: 'Flame',           tr: 'Alev', best: true },
  { stars: 1000, bonus: 200, ru: 'Созвездие', az: 'Bürc',     en: 'Constellation',   tr: 'Takımyıldız' },
]

export function packageByStars(stars: number): StarPackage | undefined {
  return PACKAGES.find((p) => p.stars === stars)
}

export function packageName(p: Loc, lang: Lang): string {
  return loc(p, lang)
}

/** Итого к начислению за оплаченную сумму: сам пакет плюс бонус, если он есть. */
export function creditFor(paidStars: number): number {
  return paidStars + (packageByStars(paidStars)?.bonus ?? 0)
}

/**
 * Пакеты PWA-версии (оплата через lava). Набор свой, потому что у lava
 * минимальная цена товара — $5, и дешёвый Telegram-вход ($1.30 за 100 ✦) там
 * не продать. Выгода зашита в цену за звезду, отдельного «бонуса» нет:
 * начисляется ровно `stars`.
 *
 * ВАЖНО: цена `usd` обязана совпадать с ценой соответствующего товара в
 * кабинете lava — иначе на витрине одно, а спишется другое.
 */
export interface PwaPackage {
  stars: number
  usd: number
  ru: string
  az: string
  en: string
  tr: string
  best?: boolean
}

export const PWA_PACKAGES: PwaPackage[] = [
  { stars: 500,  usd: 5.0,   ru: 'Искра',     az: 'Qığılcım', en: 'Spark',         tr: 'Kıvılcım' },
  { stars: 1500, usd: 12.99, ru: 'Пламя',     az: 'Alov',     en: 'Flame',         tr: 'Alev', best: true },
  { stars: 3000, usd: 24.99, ru: 'Созвездие', az: 'Bürc',     en: 'Constellation', tr: 'Takımyıldız' },
]

export function pwaPackageByStars(stars: number): PwaPackage | undefined {
  return PWA_PACKAGES.find((p) => p.stars === stars)
}
